import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Field } from "./utils";

export function FornitoreField({ doc, setDoc }) {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [showLista, setShowLista] = useState(false);
  const [current, setCurrent] = useState(doc.fornitore ? { ragione_sociale: doc.fornitore, primary_key: doc.id_cliente } : null);
  useEffect(() => {
    if (!q) return setList([]);
    const t = setTimeout(async () => {
      const r = await api.get("/pn/anagrafica", { params: { search: q, limit: 20, dedupe: true } });
      setList(r.data.data || []);
    }, 250);
    return () => clearTimeout(t);
  }, [q]);
  const sceglFornitore = (a) => {
    setCurrent(a); setQ(""); setOpen(false); setShowLista(false);
    setDoc(d => ({ ...d, id_cliente: a.primary_key, fornitore: a.ragione_sociale, fornitore_piva: a.piva }));
  };
  return (
    <div style={{ display: "flex", alignItems: "center", marginBottom: 8, position: "relative" }}>
      <label style={{ width: 110, fontSize: 11, fontWeight: 700, color: "#37474f" }}>ANAGRAFICA</label>
      <div style={{ flex: 1, position: "relative" }}>
        <div style={{ display: "flex", gap: 4 }}>
          <input value={current?.ragione_sociale || q} onChange={e => { setQ(e.target.value); setCurrent(null); setOpen(true); }} onFocus={() => setOpen(true)} data-testid="pn-fat-fornitore"
            placeholder="Cerca fornitore o clicca ☰..."
            style={{ flex: 1, padding: "4px 8px", border: "1px solid #888", fontSize: 12, fontWeight: current ? 700 : 400 }} />
          <button onClick={() => setShowLista(true)} data-testid="pn-fat-fornitore-lista"
            title="Apri lista completa anagrafica"
            style={{ padding: "2px 10px", background: "#1565c0", border: "none", color: "white", cursor: "pointer", fontWeight: 700 }}>☰</button>
          {current && <button onClick={() => { setCurrent(null); setQ(""); setDoc(d => ({...d, id_cliente: null, fornitore: null, fornitore_piva: null})); }} title="Rimuovi" style={{ padding: "2px 8px", background: "white", border: "1px solid #c62828", color: "#c62828", cursor: "pointer" }}>✕</button>}
        </div>
        {open && list.length > 0 && (
          <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "white", border: "1px solid #888", maxHeight: 200, overflow: "auto", zIndex: 10 }}>
            {list.map(a => (
              <div key={a.primary_key} onClick={() => sceglFornitore(a)}
                style={{ padding: "5px 10px", cursor: "pointer", fontSize: 11, borderBottom: "1px solid #eee" }}
                onMouseEnter={e => e.currentTarget.style.background = "#e3f2fd"}
                onMouseLeave={e => e.currentTarget.style.background = "white"}>
                <b style={{ textTransform: "uppercase" }}>{a.ragione_sociale}</b>
                <span style={{ marginLeft: 6, color: "#888", fontSize: 10 }}>{a.piva} · {a.citta}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      {showLista && <AnagraficaListaModal onClose={() => setShowLista(false)} onSelect={sceglFornitore} />}
    </div>
  );
}

function AnagraficaListaModal({ onClose, onSelect }) {
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const carica = async () => {
    setLoading(true);
    try {
      const r = await api.get("/pn/anagrafica", { params: search ? { search, limit: 500, dedupe: true } : { limit: 500, dedupe: true } });
      setList(r.data.data || []);
    } finally { setLoading(false); }
  };
  useEffect(() => { carica(); /* eslint-disable-next-line */ }, []);
  useEffect(() => { const t = setTimeout(carica, 300); return () => clearTimeout(t); /* eslint-disable-next-line */ }, [search]);
  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 800, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={e => e.stopPropagation()} data-testid="pn-anag-lista"
        style={{ background: "white", width: "90vw", maxWidth: 1100, height: "90vh", display: "flex", flexDirection: "column" }}>
        <div style={{ background: "#1565c0", color: "white", padding: "6px 14px", display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontWeight: 700, fontSize: 13 }}>🏢 Anagrafica Fornitori</span>
          <span style={{ fontSize: 11, opacity: 0.85 }}>· clicca una riga per selezionare</span>
          <input value={search} onChange={e => setSearch(e.target.value)} data-testid="pn-anag-search"
            placeholder="Cerca ragione sociale, P.IVA, città..."
            style={{ flex: 1, padding: "4px 10px", border: "none", fontSize: 12, marginLeft: 10 }} />
          <button onClick={() => setShowForm(true)} data-testid="pn-anag-new"
            style={{ padding: "4px 10px", background: "#2e7d32", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>+ Nuovo</button>
          <button onClick={onClose} style={{ padding: "4px 10px", background: "white", color: "#1565c0", border: "none", fontWeight: 700, cursor: "pointer" }}>✕ Chiudi</button>
        </div>
        <div style={{ flex: 1, overflow: "auto" }}>
          {loading ? (
            <div style={{ padding: 30, textAlign: "center", color: "#888" }}>Caricamento...</div>
          ) : (
            <table className="sw-table sw-table-compact" style={{ fontSize: 11, width: "100%" }}>
              <thead style={{ position: "sticky", top: 0, background: "#37474f", color: "white", zIndex: 1 }}>
                <tr>
                  <th style={{ width: 32 }}>#</th>
                  <th style={{ minWidth: 250 }}>RAGIONE SOCIALE</th>
                  <th style={{ width: 130 }}>P.IVA</th>
                  <th style={{ minWidth: 140 }}>CITTÀ</th>
                  <th style={{ width: 50 }}>PROV</th>
                  <th style={{ width: 80, textAlign: "center" }}>—</th>
                </tr>
              </thead>
              <tbody>
                {list.length === 0 && <tr><td colSpan={6} style={{ padding: 30, textAlign: "center", color: "#888" }}>Nessun fornitore.</td></tr>}
                {list.map((a, i) => (
                  <tr key={a.primary_key} data-testid={`pn-anag-row-${i}`}
                    onClick={() => onSelect(a)}
                    style={{ cursor: "pointer" }}
                    onMouseEnter={e => e.currentTarget.style.background = "#e3f2fd"}
                    onMouseLeave={e => e.currentTarget.style.background = "white"}>
                    <td style={{ textAlign: "center", color: "#888", fontFamily: "monospace" }}>{i+1}</td>
                    <td style={{ fontWeight: 600, textTransform: "uppercase" }}>{a.ragione_sociale}</td>
                    <td style={{ fontFamily: "monospace", fontSize: 10 }}>{a.piva || "—"}</td>
                    <td>{a.citta || "—"}</td>
                    <td style={{ textAlign: "center", fontFamily: "monospace", fontSize: 10 }}>{a.prov || "—"}</td>
                    <td style={{ textAlign: "center" }}>
                      <button onClick={(e) => { e.stopPropagation(); onSelect(a); }}
                        style={{ padding: "2px 9px", background: "#1565c0", color: "white", border: "none", fontSize: 10, fontWeight: 700, cursor: "pointer" }}>✓ Seleziona</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div style={{ padding: "6px 14px", background: "#f5f5f5", fontSize: 11, color: "#555", borderTop: "1px solid #ddd" }}>
          {list.length} fornitori {search && `(filtrati con "${search}")`}
        </div>
        {showForm && <NuovoFornitoreModal onClose={() => setShowForm(false)} onCreated={(a) => { setShowForm(false); onSelect(a); }} />}
      </div>
    </div>
  );
}

function NuovoFornitoreModal({ onClose, onCreated }) {
  const [f, setF] = useState({ ragione_sociale: "", piva: "", citta: "", prov: "", cap: "", indirizzo: "", nazione: "ITALIA" });
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);
  const set = (k, v) => setF(d => ({ ...d, [k]: v }));
  const salva = async () => {
    if (!f.ragione_sociale.trim()) { setErr("Ragione sociale obbligatoria"); return; }
    setSaving(true); setErr(null);
    try {
      const r = await api.post("/pn/anagrafica", f);
      onCreated(r.data);
    } catch (e) { setErr(e.response?.data?.detail || "Errore"); }
    finally { setSaving(false); }
  };
  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 900, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={e => e.stopPropagation()} style={{ background: "white", width: 500 }}>
        <div style={{ background: "#2e7d32", color: "white", padding: "6px 12px", fontWeight: 700 }}>+ Nuovo Fornitore</div>
        <div style={{ padding: 14, display: "flex", flexDirection: "column", gap: 8 }}>
          {err && <div style={{ padding: 6, background: "#fff0f0", color: "#c00", fontSize: 11 }}>{err}</div>}
          <Field label="RAG. SOC." value={f.ragione_sociale} onChange={v => set("ragione_sociale", v)} testid="pn-anag-new-rs" />
          <Field label="P.IVA" value={f.piva} onChange={v => set("piva", v)} testid="pn-anag-new-piva" />
          <Field label="INDIRIZZO" value={f.indirizzo} onChange={v => set("indirizzo", v)} />
          <Field label="CAP" value={f.cap} onChange={v => set("cap", v)} />
          <Field label="CITTÀ" value={f.citta} onChange={v => set("citta", v)} />
          <Field label="PROV" value={f.prov} onChange={v => set("prov", v)} />
          <Field label="NAZIONE" value={f.nazione} onChange={v => set("nazione", v)} />
        </div>
        <div style={{ padding: 8, background: "#fafafa", display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button onClick={onClose} style={{ padding: "5px 14px", background: "white", border: "1px solid #555", cursor: "pointer" }}>Annulla</button>
          <button onClick={salva} disabled={saving} data-testid="pn-anag-new-save"
            style={{ padding: "5px 14px", background: "#2e7d32", color: "white", border: "none", fontWeight: 700, cursor: "pointer" }}>
            {saving ? "..." : "💾 Salva e seleziona"}
          </button>
        </div>
      </div>
    </div>
  );
}

export function PagamentoField({ doc, setDoc }) {
  const [opts, setOpts] = useState([]);
  useEffect(() => { api.get("/pn/pagamenti").then(r => setOpts(r.data.data || [])); }, []);
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <label style={{ width: 110, fontSize: 11, fontWeight: 700, color: "#37474f" }}>PAGAMENTO</label>
      <select value={doc.id_pagamento || ""} onChange={e => setDoc(d => ({ ...d, id_pagamento: e.target.value ? Number(e.target.value) : null }))} data-testid="pn-fat-pagamento"
        style={{ flex: 1, padding: "4px 8px", border: "1px solid #888", fontSize: 12 }}>
        <option value="">— scegli —</option>
        {opts.map(p => <option key={p.id_pagamento} value={p.id_pagamento}>[{p.id_pagamento}] {p.descrizione}</option>)}
      </select>
    </div>
  );
}
